<template>

  <div class="passwordforgotten-container">
    <div class="passwordforgotten-page">

      <div class="semanticsection-title2 primary--text">Passwort vergessen?
      </div>

      <template v-if="!confirmation">

        <form id="passwordforgottenfields">
          <v-text-field v-model="username"
                        v-validate="'required'"
                        :error-messages="errors.collect('loginname')"
                        name="loginname"
                        data-vv-as="Benutzername"
                        label="Benutzername/Vermittlernummer"
                        hint="Benutzername oder Vermittlernummer"
                        class="required" />

          <v-text-field v-model="email"
                        v-validate="'required|email'"
                        :error-messages="errors.collect('email')"
                        data-vv-as="E-Mail"
                        name="email"
                        label="E-Mail Adresse"
                        type="email"
                        class="required" />

        </form>

        <v-btn id="submit-btn"
               :disabled="isloading || errors.count() > 0"
               color="primary white--text"
               @click="resetPassword">Passwort zurücksetzen
        </v-btn>

        <div class="pw-info">Füllen Sie bitte beide Felder aus.<br>Sie erhalten Ihr neues Passwort per E-Mail.
        </div>

      </template>

      <template v-else>

        <success-failure-display message="Wir haben Ihr Passwort erfolgreich für Sie zurückgesetzt."/>

        <div class="pw-info">Sie erhalten in Kürze eine E-Mail mit Ihrem neuen Passwort.
        </div>

      </template>

      <v-snackbar v-model="error"
                  :timeout="10000"
                  color="error">
        <span class="text-center">
          <v-icon color="white">warning
          </v-icon>
          <template v-if="errormessage">
            {{ errormessage }}
          </template>
          <template v-else>
            Passwort konnte nicht zurückgesetzt werden.<br>Bitte überprüfen Sie Ihre Eingaben.
          </template>
        </span>
      </v-snackbar>

    </div>
  </div>
</template>

<script>

import ValidationMixin from "@/components/helper/ValidationMixin";
import SuccessFailureDisplay from "@/components/SuccessFailureDisplay";
// eslint-disable-next-line
import httpService from '../../helper/httpService';

export default {
  components: { SuccessFailureDisplay },
  mixins: [ ValidationMixin ],
  data: function () {
    return {
      username: "",
      email: "",
      error: false,
      errormessage: null,
      isloading: false,
      confirmation: false
    };
  },
  methods: {
    resetPassword: function () {
      this.isloading = true;
      this.error = false;
      this.$validator.validateAll()
        .then((result) => {
          if (!result) throw new Error();
          return httpService.resetPassword({ username: this.username, email: this.email });
        })
        .then(() => {
          this.isloading = false;
          this.confirmation = true;
        })
        .catch((err) => {
          this.error = true;
          this.errormessage = err.status === 403 ? "Der angegebene Benutzer besitzt keine Berechtigung zum Zurücksetzen des Passworts."
            : err.status === 400 ? "Bitte geben Sie Ihren Loginnamen ein (nicht die Vermittlernummer)."
            : null;
          this.isloading = false;
        });
    }
  }
};
</script>


<style>
.passwordforgotten-container {
  margin: 0 48px 100px 48px;
  display: flex;
  justify-content: center;
}
.passwordforgotten-page {
  max-width: 768px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.passwordforgotten-page > * {
  margin-left: auto;
  margin-right: auto;
}
.passwordforgotten-page #passwordforgottenfields {
  width: 344px;
  margin: 0 auto;
}
.passwordforgotten-page #submit-btn {
  margin: 24px auto 40px auto;
}
.passwordforgotten-page .pw-info {
  text-align: center;
}
.passwordforgotten-page .success-failure-display {
  margin-top: 0!important;
  width: 100%;
}
</style>
